'use strict';

import React from 'react';
import PubSub from 'pubsub-js';
//require('styles//Map.css');

class StreetView extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			API_KEY: "AIzaSyBN4rv7yOZNb-lZuGPeQsq6kz57cfqfqzE",
			SPOTS: null,
			SPOT: null,
			defaultLat: 48.8729380,
			defaultLng: 2.3598986,
			userLat: null,
			userLng: null,
			panorama: null,
			status: ''
		}

		this.initializeApp = this.initializeApp.bind(this)
	}

	componentDidMount(){
		google.maps.event.addDomListener(window, "load", this.initializeApp);
		
		PubSub.subscribe('STATUS', (e,d) => {
			//console.log(e)
			//console.log(d)
			switch(d.type){
				case "INITIALIZE":
					this.setSpot(d.data[0], d.data[1])
					this.initPanorama()
					break;

				case "TELEPORT":
					//console.log(this)
					//console.log(d.data)
					this.setSpot(d.data[0], d.data[1])
			
					this.teleport();
					break;

				case "TELEPORT_FALLBACK":
					this.geolocFallBack();
					break;
			}
			
			
		});
	}

	initializeApp(){
		this.client = new google.maps.StreetViewService();
		//this.initPanorama()
		
		// PubSub.publish('STATUS', {type:"FETCH ..."});
		// this.setState({
		// 	SPOTS: this.props.spots
		// })
		
		//this.geoloc()
	}

	geoloc(){
		console.log("Geoloc ...");
		PubSub.publish('STATUS', {type:"GEOLOC ..."});
		
		let self = this;

		try {
			//if (navigator.geolocation) {
			//console.log(navigator)
		    navigator.geolocation.getCurrentPosition( (position) => {
		    	console.log(position)
		    	self.setState({
		    		userLat: position.coords.latitude,
		    		userLng: position.coords.longitude
		    	});

		    	self.setSpot(position.coords.latitude, position.coords.longitude)
		    	self.initPanorama()

		    },  (error) => {
	  			if (error.code == error.PERMISSION_DENIED){

	  			    this.geolocFallBack()
	  				self.initPanorama()
	      			console.log("you denied me :-(");
	  			}
			}, {maximumAge:60000, timeout:5000});
			// } else {
			//     this.geolocFallBack();
			// }
		} catch(err) {
			console.log(err);
			this.geolocFallBack();
		}
		
	}

	geolocFallBack(){
		//console.log("geolocFallBack")
		this.setSpot(this.state.defaultLat, this.state.defaultLng)
		//SPOT = new google.maps.LatLng(this.state.defaultLat, this.state.defaultLng);
		this.initPanorama()
	}

	setSpot(lat, lng){
		this.setState({
			SPOT: new google.maps.LatLng(lat, lng),
			status: 'teleporting'
		})
	}

	initPanorama(){
		let self = this;
		//console.log("INITIALIZING ...")
		PubSub.publish('STATUS', {type:"INITIALIZING ..."});

	    let panoramaOptions = {
	    	position: this.state.SPOT,
	    	disableDefaultUI: false,
	    	linksControl: false,
	        panControl: false,
	        enableCloseButton: false,
	        addressControl: false,
	        fullscreenControl: false,
	        zoomControl: false,
	      	pov: {
	        	heading: 0,
	        	pitch:0,
	        	zoom:1
	      	}
	    };
	    
	    this.panorama = new google.maps.StreetViewPanorama(document.getElementById("pano"), panoramaOptions)
	    this.panorama.setVisible(true);
	    
	    //PubSub.publish('STATUS', "TELEPORT")
	    this.panorama.addListener('position_changed', function() {	
	    	console.log("position_changed")
	    });

	    this.panorama.addListener('status_changed', function() {
	       	console.log("status_changed",self.state.status )
	       	if(self.state.status == 'teleporting')
	       		self.getLocationInfo();
	    });

	    
	}

	teleport(){
		this.panorama.setPosition(this.state.SPOT);
		this.setState({
			status: 'teleporting'
		})
	}

	getLocationInfo(){
		let self = this;

		this.client.getPanoramaByLocation(this.state.SPOT, 50, function(data, status){
	console.log(data)
			if(data){
				
				PubSub.publish('STATUS', {
					type:"LOCATION_INFO",
					data: {
						url: 'http://maps.google.com/maps?q='+self.state.SPOT.lat()+','+self.state.SPOT.lng(),
						latitude: self.state.SPOT.lat().toFixed(7),
						longitude: self.state.SPOT.lng().toFixed(7),
						shortDescription:data.location.shortDescription
					}
				});
				self.setHeading(data.tiles.centerHeading);
				//window.location.hash = SPOT.lat().toFixed(7)+","+SPOT.lng().toFixed(7);
				//setHeading();
			}else{
				console.log("needs to teleport again")
				PubSub.publish('STATUS', {type:"TELEPORT_DONE"});
			}
		});
	}

	setHeading(_heading){
		this.panorama.setPov({
	        heading: _heading,
	        pitch: 0
	    });

		this.setState({
			status: ''
		});
		
		setTimeout(function(){
			PubSub.publish('STATUS', {type:"TELEPORT_DONE"});

		}, 1000)
		
	}

	componentDidUpdate(){
		//console.log(this.state)
		
	}

  	render() {
    	return (
      		<div className="map-component">
        		<div id="pano"></div>
        		<div id="map"></div>
      		</div>
    	);
  	}
}

StreetView.displayName = 'StreetView';

// Uncomment properties you need
// Map.propTypes = {};
// Map.defaultProps = {};

export default StreetView;



// WEBPACK FOOTER //
// ./src/components/StreetView.js